import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { isPlain } from "./is-plain";

/**
 * `mBFetch()`/`post()` wrap the native `fetch()` with mibaby-wide defaults
 * (same-origin credentials, an `X-Requested-With` header) and automatic
 * request-body encoding by `Content-Type`: a plain object body is
 * JSON-stringified, turned into `FormData`, or URL-encoded depending on the
 * resolved content type, so callers can pass a plain object instead of
 * pre-encoding the body themselves.
 *
 * Part of the mibaby-common shared utilities & types component — see docs/wiki/System/shared/mibaby-common.md.
 */

export const DEFAULTS = {
  credentials: "same-origin",
  headers: {
    "X-Requested-With": "XMLHttpRequest"
  }
};
export function mBFetch(input, options = {}) {
  options = _objectSpread(_objectSpread(_objectSpread({}, DEFAULTS), options), {}, {
    headers: _objectSpread(_objectSpread({}, DEFAULTS.headers), options.headers)
  });
  const {
    method,
    body,
    headers
  } = options;
  if (method === "POST" && !(headers["Content-Type"] || headers["content-type"])) {
    if (body instanceof FormData) {
      headers["Content-Type"] = "multipart/form-data";
    } else {
      headers["Content-Type"] = "application/x-www-form-urlencoded";
    }
  }
  const contentType = headers["Content-Type"];
  if (contentType && isPlain(body)) {
    switch (contentType) {
      case "application/json":
        options.body = JSON.stringify(body);
        break;
      case "multipart/form-data":
        options.body = Object.entries(body).reduce((data, [k, v]) => (data.append(k, v), data), new FormData());
        break;
      default:
        options.body = Object.entries(body).reduce((data, [k, v]) => (data.append(k, typeof v == "object" ? JSON.stringify(v) : v), data), new URLSearchParams());
    }
  }
  return fetch(input, options);
}
export function post(input, options = {}) {
  return mBFetch(input, _objectSpread(_objectSpread({}, options), {}, {
    method: "POST",
    headers: _objectSpread(_objectSpread({}, options.headers), {}, {
      "Content-Type": "application/json"
    })
  }));
}
export default mBFetch;
//# sourceMappingURL=fetch.mjs.map